import * as React from 'react';
import infoIcon from '@xero/xui-icon/icons/info';
import XUIIcon from '@xero/xui/react/icon';
import XUITooltip from '@xero/xui/react/tooltip';

export interface ISetupSegmentProps {
    title: string;
    info?: string | undefined;
    footer: string;
}

export default class SetupSegment extends React.Component<ISetupSegmentProps> {
    constructor(props: ISetupSegmentProps) {
        super(props);
    }

    public render() {
        return (
            <div className='xui-margin-bottom-xlarge'>
                <div className='xui-u-flex xui-u-flex-align-center xui-margin-bottom-xsmall'>
                    <div className='xui-heading-small xui-margin-right-xsmall'>{this.props.title}</div>
                    {this.props.info ? (
                        <XUITooltip
                            trigger={
                                <span>
                                    <XUIIcon icon={infoIcon} color='black-faint' className='xui-u-flex ' />
                                </span>
                            }
                        >
                            {this.props.info}
                        </XUITooltip>
                    ) : null}
                </div>
                {this.props.children}
                <div className='xui-text-secondary'>{this.props.footer}</div>
            </div>
        );
    }
}
